var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophyRank1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99501 19.2473H14.993L15.7731 20.0948H5.21484L5.99501 19.2473Z",
    fill: "#C7C7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4091 19.7241L15.7731 20.0949H5.21484L5.57892 19.7241H15.4091Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7731 20.0417H5.21484V27.7223H15.7731V20.0417Z",
    fill: "#C7C7C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33056 27.7222H16.6572L17.9055 28.7286H3.03027L4.33056 27.7222Z",
    fill: "#C7C7C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3334 28.2522L17.9055 28.7289H3.03027L3.65441 28.2522H17.3334Z",
    fill: "#979797"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9055 28.729H3.03027V30.0003H17.9055V28.729Z",
    fill: "#C7C7C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2014 22.7434H5.73535V26.875H15.2014V22.7434Z",
    fill: "#9F8F8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3974 0.708127C15.8773 3.30361 15.4612 6.42879 14.629 8.75943C13.7968 10.9841 12.6526 11.249 11.8724 12.7851C11.2483 14.0034 11.5603 14.9038 12.0804 15.8573C12.3405 16.334 12.4965 16.5459 12.0804 16.7578C12.2365 17.6582 13.4848 18.7176 14.2129 18.9295V19.3003C13.1727 19.5651 7.81552 19.6181 6.72328 19.3003V18.9295C7.45144 18.7176 8.69971 17.6582 8.85575 16.7578C8.43966 16.5459 8.6477 16.334 8.85575 15.8573C9.37586 14.8509 9.68793 13.9504 9.06379 12.7851C8.28362 11.249 7.08736 10.9312 6.30719 8.75943C5.52702 6.42879 5.11093 3.30361 4.59082 0.708127C6.51524 0.231405 14.473 0.231405 16.3974 0.708127Z",
    fill: "#FFDF66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3446 1.07908C17.1248 -0.0332715 19.7774 0.0196975 19.9854 2.40331C20.2455 5.36958 16.7607 7.91209 14.1602 9.28929L14.5762 8.22991C16.3446 6.90568 18.269 5.89927 18.7892 3.6216C19.0492 2.56221 18.6851 1.39689 17.6969 1.50283C17.1768 1.5558 17.0728 1.76768 17.0208 1.92658C16.8647 2.40331 16.5007 2.82706 16.1886 2.933C15.5645 3.19784 15.1484 2.66815 16.3446 1.07908Z",
    fill: "#FFDF66"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64282 1.07908C3.86265 -0.0332715 1.21007 0.0196975 1.00203 2.40331C0.74197 5.36958 4.22673 7.91209 6.82729 9.28929L6.4112 8.22991C4.64282 6.90568 2.7184 5.89927 2.19829 3.6216C1.93823 2.56221 2.30231 1.39689 3.29052 1.50283C3.81064 1.5558 3.91466 1.76768 3.96667 1.92658C4.17472 2.45628 4.48678 2.88003 4.79885 2.98597C5.37098 3.19784 5.83908 2.66815 4.64282 1.07908Z",
    fill: "#FFDF66"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7731 27.2988H5.21484V27.7226H15.7731V27.2988Z",
    fill: "#979797"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4678 19.2471H14.9928L15.7729 20.0946H10.4678V19.2471Z",
    fill: "#979797"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4088 19.7236L15.7729 20.0944H10.4678V19.7236H15.4088Z",
    fill: "#333333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7209 20.0415H10.4678V27.722H15.7209V20.0415Z",
    fill: "#979797"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4678 27.7219H16.6571L17.9054 28.7283H10.4678V27.7219Z",
    fill: "#979797"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 28.252L17.9054 28.7287H10.4678V28.252H17.3333Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9054 28.7283H10.4678V29.9995H17.9054V28.7283Z",
    fill: "#979797"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2008 22.7432H10.4678V26.8748H15.2008V22.7432Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3971 0.707942C15.8769 3.30343 15.4609 6.4286 14.6287 8.75924C13.7965 10.9839 12.6522 11.2488 11.8721 12.7849C11.2479 14.0032 11.56 14.9037 12.0801 15.8571C12.3402 16.3338 12.4962 16.5457 12.0801 16.7576C12.2362 17.6581 13.4844 18.7174 14.2126 18.9293V19.3001C13.6925 19.459 12.0801 19.512 10.4678 19.512V0.337158C12.9643 0.337158 15.4088 0.443096 16.3971 0.707942Z",
    fill: "#FFC63B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3446 1.07884C17.1248 -0.0335157 19.7774 0.0194534 19.9854 2.40306C20.2455 5.36933 16.7607 7.91185 14.1602 9.28905L14.5762 8.22966C16.3446 6.90544 18.269 5.89902 18.7892 3.62135C19.0492 2.56197 18.6851 1.39665 17.6969 1.50259C17.1768 1.55556 17.0728 1.76743 17.0208 1.92634C16.8647 2.40306 16.5007 2.82682 16.1886 2.93275C15.5645 3.1976 15.1484 2.66791 16.3446 1.07884Z",
    fill: "#FFC63B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7209 27.2986H10.4678V27.7223H15.7209V27.2986Z",
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4941,
    cy: 7.45624,
    r: 4.49624,
    fill: "url(#paint0_linear)",
    stroke: "white",
    strokeWidth: 0.499582
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5723 8.75998V9.23755H9.65726V8.75998H10.3348V6.89203C10.3348 6.85125 10.3356 6.80969 10.3372 6.76734C10.3387 6.725 10.3411 6.68186 10.3442 6.63795L9.89722 7.00966C9.86586 7.03318 9.83527 7.04808 9.80547 7.05436C9.77568 7.06063 9.74744 7.06141 9.72078 7.05671C9.69412 7.05044 9.67059 7.04102 9.6502 7.02848C9.62982 7.01436 9.61413 7.00025 9.60315 6.98613L9.39848 6.71088L10.4477 5.82161H10.9818V8.75998H11.5723Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 8.39927,
    y: 5.32195,
    width: 4.17211,
    height: 5.41427,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.499582
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.499582
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.4941,
    y1: 2.71021,
    x2: 10.4941,
    y2: 12.2023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8621B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyRank1);
export default __webpack_public_path__ + "static/media/trophy-rank-1.63e704c6befbc284b7ba455c2254bbf4.svg";
export { ForwardRef as ReactComponent };